module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"checklist":"Checklist","draft":{"none":{"title":"No Current Draft","body":"There is not currently a Draft version of this Form. If you want to make changes to the Form or its Media Files, start by creating a Draft using the button above."},"any":{"versionCaption":{"full":"{draftVersion} of this Form.","draftVersion":"Draft version"}}}}}')
  delete Component.options._Ctor
}
